import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Modal, Typography, message } from 'antd';
import SignatureCanvas from 'react-signature-canvas';
import { useDispatch } from 'react-redux';
import { addVisitorRequest } from '../../../redux/actions/visitorActions';
import { fetchVisitorTypesRequest } from '../../../redux/actions/visitorTypeActions';
import { fetchSiteRequest } from '../../../redux/actions/siteActions';
import { useNavigate } from 'react-router-dom';
import './AddVisitorForm.css';

const { Title } = Typography;

const VisitorForm = () => {
  const [formData, setFormData] = useState({
    visitorname: '',
    suite: '',
    companyname: '',
    phone: '',
    licenseplate: '',
    recono: '',
    sign_timein: '',
  });

  const [signatureModalVisible, setSignatureModalVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const signatureRef = React.useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Fetch visitor types and site data on mount
  useEffect(() => {
    dispatch(fetchVisitorTypesRequest());
    dispatch(fetchSiteRequest());
  }, [dispatch]);

  // Initialize form data from localStorage
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setFormData((prev) => ({
        ...prev,
        siteid: user.empsiteid || '',
      }));
    }
    const visitortype = JSON.parse(localStorage.getItem('visitortype'));
    if (visitortype) {
      setFormData((prev) => ({
        ...prev,
        visitortypeid: visitortype.id || '',
      }));
    }
  }, []);

  // Handle form field changes
  const handleChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
  };

  const handleSignatureClear = () => {
    signatureRef.current.clear();
  };

  const handleSignatureSave = () => {
    if (signatureRef.current.isEmpty()) {
      message.warning('Please draw a signature before saving.');
      return;
    }
    const signatureData = signatureRef.current.toDataURL();
    handleChange('sign_timein', signatureData);
    setSignatureModalVisible(false);
  };

  const handleSignatureCancel = () => {
    setSignatureModalVisible(false);
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.visitorname) newErrors.visitorname = 'Name is required.';
    if (!formData.suite) newErrors.suite = 'Suite is required.';
    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === 'sign_timein' && formData[key]) {
          const signatureBlob = dataURLToBlob(formData[key]);
          formDataToSend.append(key, signatureBlob, 'signature.png');
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });
      dispatch(addVisitorRequest(formDataToSend));
      message.success('Thanks for visiting!');
      navigate('/visitorform');
    } else {
      message.error('Please correct the errors in the form.');
    }
  };

  const dataURLToBlob = (dataURL) => {
    const base64String = dataURL.split(',')[1]; // Get the base64 string after the comma
    const binary = atob(base64String); // Decode the base64 string
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: 'image/png' });
  };

  const visitorTypeFromStorage = JSON.parse(localStorage.getItem('visitortype'));
  
  return (
    <div className="visitor-form-container">
      <Title level={3} className="form-title">
        Visitor Registration
  
      </Title>
      <Form layout="vertical" onFinish={handleSubmit} className="visitor-form">
      <div>
        <h3 className="visitor-type-heading">
                        {visitorTypeFromStorage?.visitortype || 'Visitor Type'}
                    </h3>
                    </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Name" required>
              <Input
                size="large"
                placeholder="Enter visitor's name"
                value={formData.visitorname}
                onChange={(e) => handleChange('visitorname', e.target.value)}
              />
              {errors.visitorname && <span className="error">{errors.visitorname}</span>}
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Suite" required>
              <Input
                size="large"
                placeholder="Enter suite number"
                value={formData.suite}
                onChange={(e) => handleChange('suite', e.target.value)}
              />
              {errors.suite && <span className="error">{errors.suite}</span>}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Company Name">
              <Input
                size="large"
                placeholder="Enter company name (optional)"
                value={formData.companyname}
                onChange={(e) => handleChange('companyname', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Phone Number">
              <Input
                size="large"
                placeholder="Enter  phone number"
                maxLength={10}
                value={formData.phone}
                onChange={(e) => handleChange('phone', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="License Plate" >
              <Input
                size="large"
                placeholder="Enter license plate number"
                value={formData.licenseplate}
                onChange={(e) => handleChange('licenseplate', e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item label="Reco No" >
              <Input
                size="large"
                placeholder="Enter RECO number"
                value={formData.recono}
                onChange={(e) => handleChange('recono', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item>
              {formData.sign_timein ? (
                <div className="signature-preview">
                  <img
                    src={formData.sign_timein}
                    alt="Signature Preview"
                    className="signature-image"
                  />
                  <Button
                    type="link"
                    onClick={() => setSignatureModalVisible(true)}
                  >
                    Edit Signature
                  </Button>
                </div>
              ) : (
                <Button
                  type="primary"
                    className="custom-button"
                  onClick={() => setSignatureModalVisible(true)}
                  
                >
                  Add Signature
                </Button>
              )}
            </Form.Item>
          </Col>
        </Row>
         <Row
          justify="center"
            align="middle"
          >
         <Col>
    <div className="submit-button custom-row">
      <Button
        type="primary"
        htmlType="submit"
        size="small" 
        style={{
          width: '200px', 
          display: 'block', 
          margin: '0 auto',
          lineHeight: '5px',
          height:' 32px',
        }}
      >
        Submit
      </Button>
    </div>
  </Col>
</Row>

      </Form>

      <Modal
        open={signatureModalVisible}
        title="Add/Edit Signature"
        footer={null}
        onCancel={handleSignatureCancel}
        centered
        width={400}
      >
        <SignatureCanvas
          ref={signatureRef}
          canvasProps={{
            width: 350,
            height: 150,
            className: 'sigCanvas',
          }}
          backgroundColor="#fff"
          penColor="black"
        />
        <div className="signature-modal-actions">
          <Button onClick={handleSignatureClear} danger className="clear-button">
            Clear
          </Button>
          <Button onClick={handleSignatureSave} type="primary" className="save-button">
            Save
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default VisitorForm;
